const getThreadBlockerActivityText = (event) => {
  if (!Array.isArray(event?.lines)) {
    return '';
  }

  return event.lines
    .map((line) => {
      return String(line?.text || '');
    })
    .join('\n')
    .trim();
};

export default getThreadBlockerActivityText;
